'use client';
import cn from 'classnames';
import Link from 'next/link';

import Text from '@/components/common/Text/Text';
import SlickCarousel from '@/components/common/SlickCarousel/SlickCarousel';
import AspectRatioImage from '@/components/common/AspectRatioImage/AspectRatioImage';

import { BuilderImageProps } from '@/types/Builder';

import './HalfPhotoGridFeature.style.scss';

type HalfPhotoGridFeatureItem = {
  className?: string;
  image: BuilderImageProps;
  headline: string;
  text: string;
  link: string;
};

function HalfPhotoGridFeatureItem(props: HalfPhotoGridFeatureItem) {
  const { image, headline, text, link } = props;

  return (
    <div className='HalfPhotoGridFeatureItem'>
      <Link href={link}>
        <AspectRatioImage
          alt={image.imageAltText}
          height={image.imageHeight}
          width={image.imageWidth}
          src={image.image}
        />
        <div className='item-inner-container'>
          <Text
            className='item-headline'
            variant='title-m'
            italic
          >
            {headline}
          </Text>
          <Text
            className='item-text'
            variant='text-m'
          >
            {text}
          </Text>
        </div>
      </Link>
    </div>
  );
}

type HalfPhotoGridFeatureProps = {
  className?: string;
  items: HalfPhotoGridFeatureItem[];
};

function HalfPhotoGridFeature(props: HalfPhotoGridFeatureProps) {
  const { className = '', items } = props;
  return (
    <div className={cn('HalfPhotoGridFeature', className)}>
      <div className='mobile-container'>
        <SlickCarousel
          className='HalfPhotoGridFeature-SlickCarousel'
          slickSettings={{
            dots: true,
            arrows: false,
            swipeToSlide: true
          }}
        >
          {items.map((item, index) => {
            return (
              <HalfPhotoGridFeatureItem
                {...item}
                key={index}
              />
            );
          })}
        </SlickCarousel>
      </div>
      <div className='desktop-container'>
        {items.map((item, index) => {
          return (
            <HalfPhotoGridFeatureItem
              {...item}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
}

export default HalfPhotoGridFeature;
